import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100vh;
  }
`;

export const ModalBaileys = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(250, 250, 250, 0.97);
  display: flex;
  justify-content: center;
  overflow-y: auto;
  z-index: 10;

  & > section {
    position: absolute;
    width: 100%;
    max-width: 700px;
    left: auto;
    top: auto;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    margin-top: 10%;
    padding-bottom: 30px;
    @media screen and (orientation: portrait) {
      width: 93%;
      margin-top: 15px;
    }
  }
`;

export const BailetsBlock = styled.div`
  width: 100%;
  background: #fff;
  border: 1px solid #eee;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 27px;
  padding-left: 32px;
  padding-right: 32px;
  box-sizing: border-box;

  & > .closeIcon {
     position: fixed;
    right: 0;
    top: 168px;
    z-index: 1000;
    color: #000;
    cursor: pointer;
    left: 752px;
    margin-left: auto;
    margin-right: auto;
    @media screen and (orientation: portrait) {
      position: absolute;
      right: 11px;
      top: 11px;
      left: auto;
    }
  }

  & .mansion {
    margin-bottom: 40px;
  }

  & > h2 {
    color: #000;
    text-align: center;
    font-size: 36px;
    font-weight: 900;
    padding-bottom: 56px;
  }

  & > h4 {
    color: #000;
    text-align: center;
    font-size: 22px;
    font-weight: 900;
    padding-top: 25px;
    padding-bottom: 46px;
    text-transform: uppercase;
    text-decoration: underline;
  }

  & > span {
    width: 80%;
    color: #000;
    text-align: center;
    font-size: 13px;
    font-weight: 900;
    line-height: 22px;
    letter-spacing: 0.52px;
    text-transform: uppercase;
    padding-bottom: 19px;
    @media screen and (orientation: portrait) {
      width: 95%;
    }
  }

  & > p {
    width: 80%;
    color: rgba(0, 0, 0, 0.70);
    font-size: 13px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.52px;
    text-align: justify;
    @media screen and (orientation: portrait) {
      width: 95%;
    }
  }
`;

export const ModalFooter = styled.div`
  position: absolute;
  width: 100%;
  max-width: 900px;
  left: auto;
  bottom: 0;
  padding: 20px;
  padding-bottom: 30px;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  justify-content: center;
`;

export const MenuWrap = styled.div`
  width: 100%;
  @media screen and (orientation: portrait) {
    margin-bottom: 25px !important;
  }
`;
